/**
 * Created by dok on 01/02/2017.
 */
angular.module('tf.controllers')

    .controller('CreateClusterController', ['$scope', 'FarmService', 'NotificationService', '$timeout', 'cluster',
        function ($scope, FarmService, NotificationService, $timeout, cluster) {

            $scope.settingsChanged = false;
            $scope.cluster = angular.copy(cluster);

            $scope.header = ($scope.cluster?'Edit':'New')+' Cluster';

            setTimeout(function(){$('.modal input').first().focus();},1);

            $scope.saveCluster = function(){
                $scope.isWorking = true;
                if($scope.cluster.id){
                    FarmService.updateCluster($scope.cluster).then(function () {
                        $scope.$close(true);
                    });
                } else {
                    FarmService.createCluster($scope.cluster).then(function () {
                        $scope.$close(true);
                    });
                }

            };


            var unwatch = $scope.$watch('cluster', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatch();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };
        }
    ]
);